import axios from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

export interface ApiClientConfig {
  readonly baseURL: string;

  readonly timeout?: number | undefined;

  readonly withCredentials?: boolean | undefined;
}

type ResponseInterceptorResult = AxiosResponse | Promise<AxiosResponse>;

export type ResponseInterceptor = (
  response: AxiosResponse,
) => ResponseInterceptorResult;

export type ErrorInterceptor = (error: unknown) => unknown;

export function createApiClient(config: ApiClientConfig): AxiosInstance {
  const instance = axios.create({
    baseURL: config.baseURL,
    timeout: config.timeout ?? 30000,
    withCredentials: config.withCredentials ?? true,
    // Note: Don't set default Content-Type header.
    // Axios automatically sets 'application/json' for objects
    // and 'multipart/form-data' with boundary for FormData.
  });

  return instance;
}

export function addResponseInterceptor(
  client: AxiosInstance,
  onFulfilled: ResponseInterceptor,
  onRejected?: ErrorInterceptor,
): number {
  return client.interceptors.response.use(onFulfilled, onRejected);
}
